import React, { useContext } from 'react';
import {
  Formik, Form, Field, useFormikContext,
} from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { InputTextComponent, TextAreaComponent, DropdownComponent } from '../../../components/prime-formik';
import { AccountContext } from '../../../components/AccountContext';

const i18nMessages = defineMessages({
  competencyCode: {
    id: 'menu.item-bank-management.competency-code',
    defaultMessage: 'Competency Code',
  },
  competencyDisplayName: {
    id: 'menu.item-bank-management.competency-display-name',
    defaultMessage: 'Competency Display Name',
  },
  competencyDescription: {
    id: 'menu.item-bank-management.competency-description',
    defaultMessage: 'Competency Description',
  },
  library: {
    id: 'menu.item-bank-management.library',
    defaultMessage: 'Library',
  },
});

const AddCompetency = ({ availableLibraries }) => {
  const currentAccount = useContext(AccountContext);
  const { formatMessage } = useIntl();
  const history = useHistory();
  const {
    setFieldValue,
    values: { competency, library },
  } = useFormikContext();

  const initialValues = {
    code: competency.code ? competency.code : '',
    displayName: competency.displayName ? competency.displayName : '',
    description: competency.description ? competency.description : '',
    libraryCode: competency.libraryCode ? competency.libraryCode : '',
  };

  const validationSchema = Yup.object({
    code: Yup.string().required(),
    displayName: Yup.string().required(),
    description: Yup.string().required(),
    libraryCode: Yup.string().required(),
  });

  const libraryOptions = availableLibraries
    .map(surveyLibrary => ({
      value: surveyLibrary.code,
      label: surveyLibrary.displayName,
    }));

  if (library.code) {
    libraryOptions.push({
      value: library.code,
      label: library.displayName,
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.resetForm();

        setFieldValue('competency', { ...values });

        history.push(`/accounts/${currentAccount}/add-itembank-survey-content/new/add-ability`);
      }}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <div className="dimension-basic-data-form-controls">
            <div>
              <div className="input-label">{formatMessage(i18nMessages.competencyCode)}</div>
              <div>
                <Field id="code" name="code" component={InputTextComponent} />
              </div>
            </div>
            <div>
              <div className="input-label">{formatMessage(i18nMessages.competencyDisplayName)}</div>
              <div>
                <Field id="displayName" name="displayName" component={InputTextComponent} />
              </div>
            </div>
            <div>
              <div className="input-label">{formatMessage(i18nMessages.competencyDescription)}</div>
              <div>
                <Field id="description" name="description" component={TextAreaComponent} />
              </div>
            </div>
          </div>

          <div className="context-option-controls">
            <div className="input-label">{formatMessage(i18nMessages.library)}</div>
            <div>
              <Field
                id="libraryCode"
                name="libraryCode"
                component={DropdownComponent}
                options={libraryOptions}
              />
            </div>
          </div>
          <div>
            <FormattedMessage id="actions.save" defaultMessage="Save">
              {text => <Button type="submit" label={text} />}
            </FormattedMessage>
            <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
              {text => (
                <Button
                  type="button"
                  onClick={() => history.goBack()}
                  className="p-button-secondary"
                  label={text}
                />
              )}
            </FormattedMessage>
          </div>
        </Form>
      )}
    />
  );
};

AddCompetency.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  availableLibraries: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default AddCompetency;
